<template>
  <div class="complete_content">
    <dd-header
      :headerType=1
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>パスワードリセット送信完了</h2>
        </div>
        <div class="main_content">
          <ul class="thanks">
            <li>パスワードリセットメールを自動送信しました。</li>
            <li>メールに記載されたURLよりパスワードリセットにお進みください。</li>
          </ul>
          <ul class="for_mail">
            <li>※受信制限をされている方は、「<label class="weighty">@domans.co.jp</label>」からのメールを受信許可に設定してください</li>
            <li>※メールアドレスを間違えて入力してしまった場合は、再度仮登録手続きを行ってください。</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Module
import Header from '../components/common/DcHeader'
import LoginForm from '../components/login/LoginForm'

export default {
  name: 'Login',
  components: {
    'dd-header': Header,
    'dd-login': LoginForm
  },
  data () {
    return {
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>
<style src="../css/login.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/PasswordResetConfirm.vue